import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function ModalDefinirMaterialPadrao({ show, setMostrarModalDefinirPadrao, definirComoMaterialPadrao, modulo, email }) {
  const [copiarDescobertaGuiada, setCopiarDescobertaGuiada] = useState(true);
  const [copiarHandson, setCopiarHandson] = useState(true);
  const [confirmaAcao, setConfirmaAcao] = useState(false);

  const handleOK = () => {
    if (!confirmaAcao) {
      return; // Não permite continuar se não confirmou
    }

    // Chama a função callback passando os parâmetros
    definirComoMaterialPadrao({
      modulo: modulo,
      email: email,
      copiar_descoberta_guiada: copiarDescobertaGuiada,
      copiar_handson: copiarHandson
    });

    // Reseta os estados e fecha o modal
    resetAndClose();
  };

  const resetAndClose = () => {
    setCopiarDescobertaGuiada(true);
    setCopiarHandson(true);
    setConfirmaAcao(false);
    setMostrarModalDefinirPadrao(false);
  };

  return (
    <div>
      <Modal show={show}
             size="lg"
             centered={true}
      >
        <Modal.Dialog style={{margin:0}}>
          <Modal.Header>
            <Modal.Title>Definir como Material Padrão</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Configure quais elementos serão copiados junto com o material:</p>

            <Form>
              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  id="switch-descoberta-guiada"
                  label="Copiar Descoberta Guiada"
                  checked={copiarDescobertaGuiada}
                  onChange={(e) => setCopiarDescobertaGuiada(e.target.checked)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="switch"
                  id="switch-handson"
                  label="Copiar Hands-on"
                  checked={copiarHandson}
                  onChange={(e) => setCopiarHandson(e.target.checked)}
                />
              </Form.Group>

              <hr />

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="checkbox-confirmacao"
                  checked={confirmaAcao}
                  onChange={(e) => setConfirmaAcao(e.target.checked)}
                  label={
                    <span>
                      Confirmo que <strong style={{color: 'red'}}>o material padrão atual será sobrescrito após esta ação e não poderá ser revertido.</strong>
                    </span>
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="danger"
              onClick={handleOK}
              disabled={!confirmaAcao}
            >
              Definir como Padrão
            </Button>
            <Button variant="secondary" onClick={resetAndClose}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </Modal>
    </div>
  );
}

export default ModalDefinirMaterialPadrao;
